<template>
  <div>
    <div class="appbar-list__global-dropdown__item" @click="openModal">
      <div class="title">Language</div>
      <div class="value value--language">{{ (selected || {}).name }}</div>
    </div>

    <div class="location-search">
      <modal name="language-modal" height="auto" :adaptive="true"
        @opened="openMultiselect"
      >
        <multiselect
          ref="multiselect"
          :value="selected"
          @select="onSelected"
          placeholder="Search language"
          :options="languages"
          label="name"
          :internalSearch="true"
          track-by="id"
        >
          <span slot="noResult">Nothing was found</span>
        </multiselect>
        <div></div>
      </modal>
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
  props: {
    selectedLanguage: Object
  },
  components: {
    Multiselect
  },
  data: function () {
    return {
      selected: this.selectedLanguage,
      languages: []
    }
  },
  methods: {
    onSelected (option) {
      this.selected = option
      this.$axios({url: `/global_settings/select_language?id=${option.id}`, baseURL: '', method: 'post'})
        .then(response => {
          localStorage.setItem('language_slug', option.code.toLowerCase())
          window.dispatchEvent( new Event('storage') )
          this.$modal.hide('language-modal')
          if (!window.location.href.includes("discover")) {
            location.reload()
          }
        })
    },
    openModal () {
      if (this.languages.length > 0) {
        this.$modal.show('language-modal')
      } else {
        this.$axios({url: '/global_settings/languages', baseURL: '', method: 'get'})
        .then(response => {
          this.languages = response.data
          this.$modal.show('language-modal')
        })
      }
    },
    openMultiselect () {
      this.$refs.multiselect.activate();
    },
    closeMultiselect () {
      this.$refs.multiselect.deactivate();
    }
  }
}
</script>
